/**
 * Created by Ivan on 21.05.2026
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SEASON_PASS_EXTRABAR: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});

const SeasonPassExtraBarIcon = {
    customIcon: function () {
        return Prefab.instantiate(bundles.season_pass_questsgroupicon_prefab.jsons.season_pass_extrabar_icon_prefab_json);
    },
    extraBarWeight: 100003
};
